module.exports = __webpack_public_path__ + "img/DSC_0342.0a559a10.jpg";